import type { TenantConfig } from '@/types/TenantConfig'

const purple = '#55215a'
const yellow = '#f9b800'
const lightYellow = '#fbe795'
const paleYellow = '#fff9e6'

export const immersivegatsby: TenantConfig = {
  logo: 'assets/immersivegatsby/static/logo.png',
  themeOptions: {
    primaryColor: yellow,
    secondaryColor: lightYellow,
    pageBackgroundColor: paleYellow,
    logoHeight: '70px',
    headerHeight: '90px',
    headerBackground: paleYellow,
    headerDropShadow: `0px 0px 5px 0px ${yellow}`,
    footerBackgroundColor: '#1f1f1f',
    footerTextColor: yellow,
    memberLinksColor: yellow,
    cartHeaderBackgroundColor: purple,
    dialog: {
      backgroundColor: paleYellow,
      headerBackground: lightYellow,
      headerTextColor: 'black',
      headerIconColor: 'black',
    },
    backButton: {
      backgroundColor: yellow,
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/immersivegatsby/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-240px',
        mobile: '-140px',
      },
    },
  },
}
